
import Health from "../../../assets/outline/Health.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HealthIcon({ className, dataTestid = "HealthIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Health data-testid={dataTestid} className={classes} {...rest} />
  );
}
